<template>
  <div class="py-12">
    <DataTable
      :items="recentPayments"
      :columns="columns"
      :pagination="paymentsPagination"
      @routeChange="viewPayment"
      @pageChange="handlePageChange"
    >
      <template #status="{ item }">
        <span :class="getPaymentStatusClass(item.status)"
          class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full">
          {{ getPaymentStatus(item.status) }}
        </span>
      </template>
    </DataTable>
  </div>
</template>

<script setup>
import DataTable from '@/components/general/DataTable.vue';
import { onMounted } from 'vue';
import { useAdminStore } from '@/stores/adminStore';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { ROUTES } from '@/router/routeNames';
import { getPaymentStatus, getPaymentStatusClass, columns } from '@/utils/payments';
const router = useRouter()

const adminStore = useAdminStore()

const { recentPayments, paymentsPagination } = storeToRefs(adminStore)

const handlePageChange = (page) => {
    adminStore.fetchPayments(page)
}

onMounted(() => {
    adminStore.fetchPayments()
})

function viewPayment(paymentId) {
  router.push({ name: ROUTES.ADMIN_PAYMENT, params: { id: paymentId } })
}


</script>

<style lang="scss" scoped>

</style>
